// extracted by css-extract-rspack-plugin
export default {"MediaAsset":"MediaAsset-module__MediaAsset__Licem","Image":"MediaAsset-module__Image__Y0dVS"};